import Badge from "../../../components/ui/Badge";
import { cx } from "../../../utils/classNames";
import EmptyState from "../components/EmptyState";
import ui from "../../../components/ui/ui.module.css";
import styles from "../Profile.module.css";

const ContactsSection = ({ contacts, emergencyContacts }) => {
  // Primary emergency contact first.
  const emergency = [...emergencyContacts].sort(
    (a, b) => Number(b.emergencyContact) - Number(a.emergencyContact),
  );

  return (
    <>
      <h6 className={styles.sectionTitle}>Contact numbers</h6>
      {contacts.length ? (
        <div className={ui.tableWrapper}>
          <table className={ui.table}>
            <thead>
              <tr>
                <th>Type</th>
                <th>Number</th>
                <th>Country</th>
                <th>Description</th>
              </tr>
            </thead>
            <tbody>
              {contacts.map((contact) => (
                <tr key={contact.id}>
                  <td>{contact.contactType || "—"}</td>
                  <td className={ui.strong}>{contact.contactNumber}</td>
                  <td>{contact.country || "—"}</td>
                  <td className={ui.muted}>{contact.description || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <EmptyState />
      )}

      <h6 className={styles.sectionTitle}>Emergency contacts</h6>
      {emergency.length ? (
        <div className={styles.cardGrid}>
          {emergency.map((person) => (
            <div
              key={person.id}
              className={cx(
                styles.infoCard,
                person.emergencyContact && styles.infoCardPrimary,
              )}
            >
              <div className={styles.infoCardHeader}>
                <span className={styles.infoCardTitle}>
                  {[person.firstName, person.middleName, person.lastName]
                    .filter(Boolean)
                    .join(" ")}
                </span>
                {person.emergencyContact && (
                  <Badge tone="blue" icon="bi-star-fill">
                    Primary
                  </Badge>
                )}
              </div>
              <div className={styles.infoCardLines}>
                {person.relationship && <div>{person.relationship}</div>}
                {person.phone && (
                  <div>
                    <i className="bi bi-telephone me-2"></i>
                    {person.phone}
                  </div>
                )}
                {person.email && (
                  <div>
                    <i className="bi bi-envelope me-2"></i>
                    {person.email}
                  </div>
                )}
                {person.address && (
                  <div>
                    <i className="bi bi-geo-alt me-2"></i>
                    {person.address}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <EmptyState />
      )}
    </>
  );
};

export default ContactsSection;
